import { CredusWrapper } from 'ui';
import TestReportChart from './components/TestReportChart';
import TestReportTable from './components/tables/TestReportTable';
import { IGetScoreDetails } from './report-models/report.interface';
import { useOutletContext } from 'react-router';
import ComponentLoader from '../test-management/ComponentLoader';
import EmptyState from '../../shared/EmptyState';

const TestResult = () => {
  const { data } = useOutletContext<{ data: IGetScoreDetails }>();

  return (
    <CredusWrapper>
      {data ? (
        <>
          <TestReportChart data={data} />
          {data?.reportScore?.length ? (
            <TestReportTable data={data} />
          ) : (
            <EmptyState description="No available data " margin="4rem 0rem" />
          )}
        </>
      ) : (
        <ComponentLoader />
      )}
    </CredusWrapper>
  );
};

export default TestResult;
